import styled from 'styled-components';

const NavigationPath = styled.div`
  width: 100%;
  display: flex;
`;

export default NavigationPath;
